var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.460263 7.71045L6.12026 13.3605C6.21323 13.4542 6.32383 13.5286 6.44569 13.5793C6.56754 13.6301 6.69825 13.6562 6.83026 13.6562C6.96227 13.6562 7.09298 13.6301 7.21484 13.5793C7.3367 13.5286 7.4473 13.4542 7.54026 13.3605C7.72651 13.1731 7.83105 12.9196 7.83105 12.6555C7.83105 12.3913 7.72651 12.1378 7.54026 11.9505L2.59026 6.95045L7.54026 2.00045C7.72651 1.81309 7.83106 1.55964 7.83106 1.29545C7.83106 1.03127 7.72651 0.777815 7.54026 0.590452C7.44765 0.495964 7.3372 0.420793 7.21533 0.369297C7.09345 0.3178 6.96257 0.291002 6.83026 0.290453C6.69796 0.291002 6.56707 0.3178 6.4452 0.369297C6.32332 0.420793 6.21288 0.495964 6.12026 0.590452L0.460263 6.24045C0.358758 6.33409 0.27775 6.44774 0.222342 6.57424C0.166935 6.70074 0.13833 6.83735 0.13833 6.97545C0.13833 7.11355 0.166935 7.25016 0.222342 7.37666C0.27775 7.50316 0.358758 7.61681 0.460263 7.71045Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackWhite);
export default __webpack_public_path__ + "static/media/back-white.cc1f370eb390945d8a9eb79ee3567d61.svg";
export { ForwardRef as ReactComponent };